import {Copy} from "./Copy";
import {DefaultCopy} from "./DefaultCopy";

export const EmergeCopy: Copy = {
    start: {
        header: DefaultCopy.start.header,
        id: {
            header: "Your ID",
            text: "You can use either a valid passport or New Zealand driver's licence."
        },
        selfie: {
            header: "A quick selfie",
            text: "This is to match to your ID, so we know it’s you."
        }
    }

}